
$('.dtc-reviews-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots:true,
          prevArrow: '#prev_review',
          nextArrow: '#next_review'
        },
      },
      {
        breakpoint: 468,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          prevArrow: '#prev_review',
          nextArrow: '#next_review',
        },
      }
    ],
  });


$('.videos_reviews_container').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots:true,
          prevArrow: '#prev_review',
          nextArrow: '#next_review'
        },
      },
      {
        breakpoint: 468,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true,
          prevArrow: '#prev_review',
          nextArrow: '#next_review',
        },
      }
    ],
  });